module.exports = __webpack_public_path__ + "img/marker-bg-62.973ffdf2.svg";